import { ValidationProvider } from "vee-validate/dist/vee-validate.full";

export default {
  components: {
    ValidationProvider
  },
  props: [
    "name",
    "label",
    "type",
    "validation",
    "value",
    "placeholder",
    "focus",
    "disabled"
  ],
  data() {
    return { timerId: null };
  },
  created() {},
  mounted() {
    if (this.focus) {
      this.$nextTick(() => {
        let el = this.$refs[this.name];
        if (el) {
          el.focus();
        }
      });
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (this.confirm && !newVal) {
        this.confirmVal = "";
      }
    }
  },
  methods: {
    UpdateValue(event) {
      if (event) {
        this.$emit("input", event.target.value);
        if (this.timerId) clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          this.timerId = null;

          if (this.$refs.observer)
            this.$emit("valid", this.$refs.observer.errors.length === 0);
        }, 150);
      } else {
        this.$emit("input", this.value);
      }
    }
  }
};
